// extracted by mini-css-extract-plugin
export default {"card":"m1f22lB34HZPK4T1VHAoPQ=="};